import { Box3, Group, Mesh, Object3D, Vector3 } from "three";
import { DecorItemI } from "../../../../shared";

export const getScaleWithMargin = (obj: Group | Mesh | Object3D, decor: DecorItemI): [number, number, number] => {
    const margin = (2 * (decor.margin ?? 0)) / 1000;
    if (margin <= 0) {
        return [1, 1, 1];
    }

    const isFrontBack = decor.surface === "wall" && (decor.side === "front" || decor.side === "back");
    const isLeftRight = (decor.surface === "wall" && decor.side === "left") || decor.side === "right";
    const isOnFloor = ["floor", "ceiling"].includes(decor.surface);

    const aabb = new Box3().setFromObject(obj).applyMatrix4(obj.matrixWorld);
    const size = new Vector3();
    aabb.getSize(size);

    const scaleX = (size.x + margin) / size.x;
    const scaleY = (size.y + margin) / size.y;
    const scaleZ = (size.z + margin) / size.z;

    if (isOnFloor) {
        return [scaleX, 1, scaleZ];
    }
    if (isFrontBack) {
        return [scaleX, scaleY, 1];
    }
    if (isLeftRight) {
        return [1, scaleY, scaleZ];
    }
    return [1, 1, 1];
};
